import React from "react";

import "./hero-card.scss";
import { STORAGE_KEY } from "../../../constants";

const cohortDate = process.env.GATSBY_COHORT_DATE || "Coming Soon";

const HeroCard = () => {
  const routeToCohortAndCache = () => {
    global.window.localStorage.setItem(STORAGE_KEY, "true");
  };
  return (
    <div className="hero-section">
      <div className="hero-card ae-4">
        <img src="/assets/img/hero-pg.svg" />
        <h4 className="largest">
          Your journey to product design mastery starts here.{" "}
          <span>Cohort 2</span>
        </h4>

        <p>
          <strong>
            We’re training Africa’s next generation of product designers to
            think, build and ship with confidence.
          </strong>{" "}
          Our immersive coaching program helps you develop the skills to solve
          real problems and grow a thriving design career.{" "}
          <a href="/productdesign/cohort">Learn more</a>
        </p>
        <ul>
          <li>
            <span>Next Cohort: </span>
            <strong>{cohortDate}</strong>
          </li>

          <li>
            <span>Level: </span>
            <strong>Graduates, Junior, Mid-Level.</strong>
          </li>

          <li>
            <span>Seats: </span>
            <strong>30 Seats</strong>
          </li>
        </ul>
        <button>
          <a onClick={routeToCohortAndCache} href="/productdesign/cohort">
            Enroll Now
          </a>
        </button>
      </div>
    </div>
  );
};

export default HeroCard;
